(function(window, $, undefined) {
  'use strict';

  var popupCenter = function(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 3) - (h / 3)) + dualScreenTop;

    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (newWindow && newWindow.focus) {
      newWindow.focus();
    }
  };

  // init load
  jQuery(document).ready(function(){

    try {
      jQuery(document).on('click', '.eesb-link.popup', {}, function popUp(e) {
        var self = jQuery(this);
        if(self.attr('data-href') && self.find('.eesb-text')){
          var preHref=(self.attr('data-prehref'))? self.attr('data-prehref') : "";
          popupCenter(preHref+self.attr('data-href'), self.find('.eesb-text').html(), 580, 470);
        }
        e.preventDefault();
      });
      jQuery(document).on('click', '.eesb-buttons .eesb-plus .eesb-link', {}, function popUp(e) {
        var $container=jQuery("#"+jQuery(this).data('id'));
        $container.removeClass('closed');
      });
    }
    catch (e) { // catching this adds partial support for jQuery 1.3
    }

  });

})(window, jQuery);